// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sidebar-rigth {\n  color: black;\n  background-color: white;\n  right: 0;\n  min-width: 250px;\n  width: var(--8155d33e-width_model\\ \\+\\ \\'\\%\\');\n  left: unset !important;\n  overflow-x: scroll;\n}\n.sidebar-rigth-hide {\n  background-color: transparent;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
